// import { isEmpty } from "lodash";
import { useState , useEffect} from "react";
import { Input } from "antd";

import "./input.scss";

const InputField = (props: { value: any; disabled: boolean | undefined; onBlur: (arg0: any) => void; className?: string | undefined, bordered?: true |false |undefined , taskValidations ? : any , placeholder ? : string}) => {
  const [value, setValue] = useState(props.value);

  const {maxLength , inputTypeFunc } = props.taskValidations || {};

  useEffect(() => {
    setValue(props.value)
  },[props.value])

  const handleValue = (value : string) => {
    if(inputTypeFunc && value) {
      setValue(inputTypeFunc(value))
    } else {
      setValue(value)
    }
    props.onBlur(value);
  }

  return (
    <Input
      // autoFocus={isEmpty(value)}
      placeholder={`Enter the "${props.placeholder}"` || "Enter Value"}
      bordered={props.bordered ? props.bordered : false}
      value={value}
      disabled={props.disabled}
      onChange={(e) => handleValue(e.target.value)}
      // onBlur={() => props.onBlur(value)}
      className={`${props.className} ui-component-input`}
      maxLength={maxLength ?? undefined}
    />
  );
};

export default InputField;
